import { Navigate, Outlet } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

export const ProtectedAdminRoute = () => {
  const { admin, loading } = useAdminAuth();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0F1115] text-white/60 text-sm">Checking session…</div>;
  }
  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }
  return <Outlet />;
};
